var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFilterWhite = function SvgFilterWhite(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10,
    fill: "none",
    viewBox: "0 0 16 10",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.058 10a.48.48 0 0 1-.356-.144.5.5 0 0 1-.144-.357q0-.212.144-.356A.5.5 0 0 1 7.058 9h1.865q.213 0 .356.144a.5.5 0 0 1 .144.357q0 .212-.144.356a.5.5 0 0 1-.356.143zm-3.75-4.5a.48.48 0 0 1-.357-.144.5.5 0 0 1-.143-.357q0-.213.143-.356a.5.5 0 0 1 .357-.143h9.365q.213 0 .356.144a.5.5 0 0 1 .144.357q0 .213-.144.356a.5.5 0 0 1-.356.143zM.5 1A.48.48 0 0 1 .144.856.5.5 0 0 1 0 .499Q0 .287.144.143A.5.5 0 0 1 .5 0h15q.213 0 .356.144A.5.5 0 0 1 16 .501q0 .212-.144.356A.48.48 0 0 1 15.5 1z"
  })));
};
export default SvgFilterWhite;